export default ({ resource, record: { id } }) => `${resource}s-${id}`;
